/**
 * Worker-socket relay health (chat transport). `isConnected` gates invite
 * DELIVERY (the send button) — it is NOT a user-visible status source; all
 * online/away/offline indicators come from `familyPresenceStore` (Supabase).
 * Populated by {@link usePresence}.
 *
 * @module features/p2p-chat/stores/presenceStore
 */

import { create } from 'zustand';

interface PresenceState {
  /** Whether our worker relay socket is connected. */
  readonly isConnected: boolean;
  setConnected: (connected: boolean) => void;
  clear: () => void;
}

export const usePresenceStore = create<PresenceState>((set) => ({
  isConnected: false,
  setConnected: (connected) => set({ isConnected: connected }),
  clear: () => set({ isConnected: false }),
}));
